<template>
  <div class="footer">
    <div class="container">
      <img class="brand" :src="require('@/assets/karajouludude.png')" alt="Karanteenin joululogo" />
      <span class="footertext">&copy; Karanteeni</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
.footer {
  position: relative;
  padding: 5em 0;
  overflow: hidden;
  color: black;
  font-size: 1.1em;
  font-weight: 300;
  margin-top: auto;
  flex: 0 0 auto;
  mask-image: url("~@/assets/curvewhitespaceinverted.svg");
  mask-repeat: no-repeat;
  mask-size: cover;
  mask-position: center;
  background-color: var(--footer-bg);
  margin-top: 3em;
}

.brand {
    mix-blend-mode: luminosity;
    --size: 90px;
    width: var(--size);
    height: var(--size);
    margin: 0.5em;
    filter: contrast(0.5) brightness(1.4);
    opacity: 0.5;
    
    object-fit: contain;
}

.footertext {
  font-size: 0.9em;
  letter-spacing: -0.2px;
  font-weight: 400;
  color: hsla(213, 10%, 57%, 1);
}

.container {
  margin: initial;
  max-width: initial;
  padding: 6em 0 1.5em 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.navitem {
  text-decoration: underline;
  color: black;
  opacity: 1;
  transition: all 0.1s ease;
  font-weight: 300;
  opacity: 0.8;
  margin-right: 0.4em;
}

.navitem:hover,
.navitem:active {
  opacity: 1;
}

.footer-background {
  align-items: center;
  background-color: #e9eef7;
  background-color: var(--default-bg);
  display: flex;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
  transform: scaleX(-1) scaleY(-1);
}

.footer-background img {
  flex: 0 0 auto;
  width: 100%;
  height: 500px;
  object-fit: cover;
  margin-top: -5px;
  max-width: initial;
  position: relative;
}
</style>
